import {Fragment, type ReactNode, useCallback, useMemo, useState} from 'react'
import {ModalContext} from '@/hooks/useModal'

interface ModalState {
	content: ReactNode
	id: string
}

interface ModalProviderProps {
	children: ReactNode
}

export function ModalProvider({children}: ModalProviderProps) {
	const [modals, setModals] = useState<ModalState[]>([])
	const [loading, setLoading] = useState(false)

	const closeModal = useCallback(() => {
		// Don't allow closing while loading
		if (loading) {
			return
		}
		setModals((prev) => prev.slice(0, -1))
	}, [loading])

	const openModal = useCallback((content: ReactNode) => {
		setModals((prev) => [
			...prev,
			{
				content,
				id: crypto.randomUUID(),
			},
		])
	}, [])

	const value = useMemo(
		() => ({openModal, closeModal, loading, setLoading}),
		[openModal, closeModal, loading],
	)

	return (
		<ModalContext.Provider value={value}>
			{children}
			{modals.map(({content, id}) => (
				<Fragment key={id}>{content}</Fragment>
			))}
		</ModalContext.Provider>
	)
}
